import { StoreContext } from '../../../context/Provider';
import React, { useContext, useEffect, useState } from 'react';
import { defaultColumnsSandboxTable, formatDateTime } from './utils';
import { Column } from 'primereact/column';
import { TableComponent } from '../../../components/Table';
import { FilterSandbox } from './filters';
import { ISandboxProvider } from '../../../interfaces/service/SandboxServiceManagerInterface';
import { cordinatesInventory } from '../../../pages/Inventary/components/table/BodyTemplatesTable';

// Define la interfaz para las props
interface TableSandBoxProps {
  service: ISandboxProvider;
}

// Componente React válido
export const TableSandBox: React.FC<TableSandBoxProps> = ({ service }) => {
  const [sort, setSort] = useState([{ field: '', order: -1 }]);
  const [devices, setDevices] = useState<any[]>([]);
  const context = useContext(StoreContext);
  const { dispatchLoading, historyDeviceState } = context;

  useEffect(() => {
    setDevices(historyDeviceState.state.data);
  }, [historyDeviceState.state]);

  const getColumnsToDisplayIntable = () => {
    let columns = service.columnsSelected.map((column: any, index: any) => {
      const key = index.toString();
      return (
        <Column
          key={key}
          field={column.field}
          filterField={column.field}
          dataType={column.isFilter ? column.dataType : undefined}
          header={column.header}
          style={{
            flexGrow: 1,
            flexBasis: '100px',
          }}
          bodyClassName={'!text-grey !text-sm'}
          headerClassName={'!text-black !justify-between !bg-white'}
          sortable={column.sortable}
          filterMenuStyle={{ width: '14rem' }}
          filter={false}
          body={column.body}
        />
      );
    });

    return columns;
  };
  return (
    <div className="flex w-full h-full relative flex-col gap-y-2">
      <div className="flex w-full h-24">
        {<FilterSandbox service={service} />}
      </div>

      <div className="h-full flex flex-col w-full overflow-y-auto relative  bg-white rounded-md shadow-lg p-2 ">
        <TableComponent
          value={service.tableData}
          sortField="name"
          responsiveLayout="scroll"
          className="flex h-full w-full  relative rounded"
          globalFilterFields={[]}
          resizableColumns
          setSort={setSort}
          sort={sort}
          paginator
          reorderableColumns={true}
          OnEmptyMessage="No se encontraron registros disponibles."
          loading={false}>
          {getColumnsToDisplayIntable()}
        </TableComponent>
      </div>
    </div>
  );
};
